import { helpers } from 'vuelidate/lib/validators'

const regex = '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$';

const hour = (value) => {
    const regexObj = new RegExp(regex)
    return !helpers.req(value) ||regexObj.test(value);
}

export default hour;